module.exports = __webpack_public_path__ + "static/cherrylake-map-app-9a953765b4e11397c91865dedb65935b.png";